import Phaser from 'phaser'

export default class HighscoresScene extends Phaser.Scene {
  create (params) {
    this.score = params.score || 0

    this.isMobileVersion = !this.game.device.os.desktop

    this.background = this.add.image(640, 0, 'white').setOrigin(0.5, 0).setDisplaySize(this.scale.width, this.scale.height).setAlpha(0.75).setTint(0)

    this.name = (window.localStorage.getItem('name') || 'AAA').toUpperCase()

    this.add.image(640, 100, 'hud', 'gameover')

    this.name = 'YOU'
    if (!this.isMobileVersion) {
      const enter = this.add.image(640, 620, 'hud', 'press_enter')
      this.tweens.add({
        targets: enter,
        scale: 1.05,
        yoyo: true,
        repeat: -1
      })
    }

    const highscores = this.loadHighscores()
    const rank = this.injectScore(highscores, this.score)

    let y = 200
    if (rank !== 1) {
      const top = this.add.text(640, y, '', {
        fontSize: '24pt'
      }).setOrigin(0.5, 0)
      this.highscoresText(top, highscores, 0, rank - 1)
      y += top.getBounds().height
    }
    this.new = this.add.text(640, y, '', {
      fontSize: '28pt',
      fontStyle: 'bold',
      color: 'red'
    }).setOrigin(0.5, 0)
    this.highscoresText(this.new, highscores, rank ? rank - 1 : highscores.length - 1, rank || 10, false)
    y += this.new.getBounds().height
    if (rank !== 0) {
      const top = this.add.text(640, y, '', {
        fontSize: '24pt'
      }).setOrigin(0.5, 0)
      this.highscoresText(top, highscores, rank, highscores.length)
      y += top.getBounds().height
    }

    const goBackToGame = () => {
      if (rank) {
        highscores[rank - 1].name = this.name
        this.saveHighscores(highscores)
      }
      this.scene.stop()
      this.scene.start('GameScene')
    }

    if (!this.game.device.os.desktop) {
      this.input.on('pointerup', () => { goBackToGame() })
    }

    this.input.keyboard.on('keyup-ENTER', (e) => {
      goBackToGame()
    })

    this.blinkTimer = 300
    this.blink = true

    this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
    this.scale.on('resize', () => {
      if (this.cameras.main) {
        this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
        this.background.setDisplaySize(this.scale.width, this.scale.height)
      }
    })
  }

  highscoresText (text, highscores, start, end, hide) {
    text.setText(highscores.slice(start, end).map(({ name, score }) => {
      if (hide) {
        name = '   '
      }
      const dots = '.'.repeat(20 - score.toString().length)
      return `${name} ${dots} ${score}`
    }))
  }

  injectScore (highscores, score) {
    let added = 0
    highscores.some((h, i) => {
      if (this.score > h.score) {
        added = i + 1
        highscores.splice(i, 0, { name: this.name, score })
        return true
      }
    })
    if (!added) {
      highscores.splice(9, 1, { name: this.name, score })
    } else {
      highscores.splice(10, 1)
    }
    return added
  }

  saveHighscores (highscores) {
    window.localStorage.setItem('highscores', JSON.stringify(highscores))
  }

  loadHighscores () {
    return JSON.parse(window.localStorage.getItem('highscores')) || [
      { name: 'COP', score: 1000 },
      { name: 'COP', score: 800 },
      { name: 'COP', score: 500 },
      { name: 'COP', score: 300 },
      { name: 'COP', score: 200 },
      { name: 'COP', score: 100 },
      { name: 'COP', score: 80 },
      { name: 'COP', score: 50 },
      { name: 'COP', score: 30 },
      { name: 'COP', score: 10 }
    ]
  }
}
